// extracted by mini-css-extract-plugin
module.exports = {"voluntaryPlanTagWrapper":"voluntaryPlanTag_voluntaryPlanTagWrapper__2lwTZ","voluntaryIcon":"voluntaryPlanTag_voluntaryIcon__2ZwgZ"};